<template>
	<v-stepper
	  v-model="localValue"
	  :non-linear="nonLinear"
	  :alt-labels="altLabels"
      flat
	  :class="{'rounded-0': !isValid(withLineBetween)}"
	>
		<!-- top position -->
		<v-stepper-header
		  v-if="stepersPosition === 'top'"
		  class="elevation-0"
		  :class="headerClass"
		  :style="!isValid(altLabels) ? 'height: 40px': null"
		>
			<template v-for="(step, index) in steps">
				<v-stepper-step
				  :step="step"
				  :complete="!isValid(nonLinear) && !isValid(editable) ? localValue > step : false"
                  :editable="isValid(nonLinear) || isValid(editable)"
				  :key="`${step}-step`"
                  :class="{ 'px-0 pt-2 pb-md-2 pb-0': isValid(altLabels), 'py-0': !isValid(altLabels) }"
				  :style="!isValid(withLineBetween) ? { maxWidth: Number(stepWidth) + 'px' } : null"
				>
					{{
						typeof stepsLabels === 'string'
						? stepsLabels + ' ' + step
						: Array.isArray(stepsLabels) ? stepsLabels[index] : null
					}}
				</v-stepper-step>

				<v-divider
				  :class="{'mt-5': isValid(altLabels)}"
				  v-if="
				    isValid(withLineBetween)?
						typeof steps === 'number' 
						? step !== steps
						: Array.isArray(steps) ? step !== steps.length : false
					: false"
				  :key="step"
				/>
			</template>
		</v-stepper-header>

		<!-- items & content -->
		<v-stepper-items>
			<v-stepper-content
			  v-for="step in steps"
			  :step="step"
			  :key="`${step}-content`"
			  :class="{'px-0 py-2': fillContentSpace}"
			>
				<div class="ma-1">
					<slot :name="`stepperContent.step-${step}`"></slot>
				</div>
			</v-stepper-content>
		</v-stepper-items>

		<!-- bottom position -->
		<v-stepper-header
		  v-if="stepersPosition === 'bottom'"
		  class="elevation-0"
		  :class="headerClass"
		  :style="!isValid(altLabels) ? 'height: 40px': null"
		>
			<template v-for="(step, index) in steps">
				<v-stepper-step
				  :key="`${step}-step`"
				  :step="step"
				  :complete="!isValid(nonLinear) && !isValid(editable) ? localValue > step : false"
                  :editable="isValid(nonLinear) || isValid(editable)"
                  :class="{ 'px-0 py-2': isValid(altLabels), 'py-0': !isValid(altLabels) }"
				  :style="!isValid(withLineBetween) ? { maxWidth: Number(stepWidth) + 'px' } : null"
				>
				{{
					typeof stepsLabels === 'string'
					? stepsLabels + ' ' + step
					: Array.isArray(stepsLabels) ? stepsLabels[index] : null
				}}
				</v-stepper-step>

				<v-divider
				  :class="{'mt-5': isValid(altLabels)}"
				  v-if="
				    isValid(withLineBetween)?
						typeof steps === 'number' 
						? step !== steps
						: Array.isArray(steps) ? step !== steps.length : false
					: false"
				  :key="step"
				/>
			</template>
		</v-stepper-header>
	</v-stepper>
</template>

<script>
export default {
    props:{
        steps: { type: [ Array, Number ], default: 0 },
        stepsLabels: { type: [ Array, String ], default: 'step' },
        stepWidth: { type: [ Number, String ], default: 100 },
        nonLinear: { type: [ Boolean, String ], default: true },
        editable: { type: [ Boolean, String ], default: false },
        altLabels: { type: [ Boolean, String ], default: true },
        fillContentSpace: { type: [ Boolean, String ], default: true },
        withLineBetween: { type: [ Boolean, String ], default: false },
        headerClass: { type: String , default: 'justify-start' },
		stepersPosition: {
			type: String ,
			default: 'top',
			validator(value) {
				const isValid = ['top', 'bottom'].includes(value);
				if(!isValid){
                    console.error(`stepers-position value \`${value}\` is NOT valid. value should be 'top', 'bottom'`);
                }
				return isValid;
			}
		},
        value: { type: Number, default: 1 },
    },

    computed:{
        localValue: {
            get(){
                return this.value;
            },
            set(newValue){
                this.$emit('input', newValue)
            }
        }
    },

    methods:{
        isValid(prop){ return prop || typeof(prop) === 'string' ? true : false }
    }
};
</script>

<style>
/* .v-stepper__step__step{
	border-radius: 5px;
} */
/* .v-stepper__step--active.single-step{
	outline: 1px solid #aaa;
	outline-offset: -1px;
	transition: outline .3s;
	border-radius: 5px;
} */
</style>